import { styled } from "baseui";

export const PageTitle = styled("h1", ({ $theme }) => ({
  ...$theme.typography.title,
  color: $theme.colors.contentPrimary,
}));
